import { render, staticRenderFns } from "./emailVarified.vue?vue&type=template&id=c5bd4868&scoped=true&"
import script from "./emailVarified.vue?vue&type=script&lang=js&"
export * from "./emailVarified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5bd4868",
  null
  
)

export default component.exports